import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const StarredBoardButtonRemoveStarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StarredBoardButtonRemoveStar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardStarId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBoardStar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"boardStarId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardStarId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"StarredBoardButtonRemoveStar","document":StarredBoardButtonRemoveStarDocument}} as const;
export type StarredBoardButtonRemoveStarMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
  boardStarId: Types.Scalars['ID'];
}>;


export type StarredBoardButtonRemoveStarMutation = (
  { __typename: 'Mutation' }
  & Pick<Types.Mutation, 'removeBoardStar'>
);



export type StarredBoardButtonRemoveStarMutationFn = Apollo.MutationFunction<StarredBoardButtonRemoveStarMutation, StarredBoardButtonRemoveStarMutationVariables>;

/**
 * __useStarredBoardButtonRemoveStarMutation__
 *
 * To run a mutation, you first call `useStarredBoardButtonRemoveStarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarredBoardButtonRemoveStarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starredBoardButtonRemoveStarMutation, { data, loading, error }] = useStarredBoardButtonRemoveStarMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      boardStarId: // value for 'boardStarId'
 *   },
 * });
 */
export function useStarredBoardButtonRemoveStarMutation(baseOptions?: Apollo.MutationHookOptions<StarredBoardButtonRemoveStarMutation, StarredBoardButtonRemoveStarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StarredBoardButtonRemoveStarMutation, StarredBoardButtonRemoveStarMutationVariables>(StarredBoardButtonRemoveStarDocument, options);
      }
export type StarredBoardButtonRemoveStarMutationHookResult = ReturnType<typeof useStarredBoardButtonRemoveStarMutation>;
export type StarredBoardButtonRemoveStarMutationResult = Apollo.MutationResult<StarredBoardButtonRemoveStarMutation>;
export type StarredBoardButtonRemoveStarMutationOptions = Apollo.BaseMutationOptions<StarredBoardButtonRemoveStarMutation, StarredBoardButtonRemoveStarMutationVariables>;